import React from "react";
import ReactDOM from "react-dom";
import App from "./app/App";
import "bootstrap/dist/css/bootstrap.css";

import {AppGlobalContext} from "./AppContext";
import {NormalizationProvider} from "./NormalizationContext";

ReactDOM.render(
    <AppGlobalContext>
        <NormalizationProvider>
            <App />
        </NormalizationProvider>
    </AppGlobalContext>,
    document.getElementById("root")
);
